import { Icon } from '@chakra-ui/react';

export default function StatusPausedIcon(props) {
  return (
    <Icon
      width='24px'
      height='24px'
      viewBox='0 0 24 24'
      fill='none'
      color='live.primary'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M12 20.3281C7.64844 20.3281 4.03125 16.7109 4.03125 12.3594C4.03125 8 7.64062 4.39062 11.9922 4.39062C16.3516 4.39062 19.9688 8 19.9688 12.3594C19.9688 16.7109 16.3594 20.3281 12 20.3281ZM9.72656 15.5H10.5156C10.9219 15.5 11.1016 15.2812 11.1016 14.9688V9.73438C11.1016 9.42969 10.9219 9.21094 10.5156 9.21094H9.72656C9.32812 9.21094 9.14844 9.42969 9.14844 9.73438V14.9688C9.14844 15.2812 9.32812 15.5 9.72656 15.5ZM13.5 15.5H14.2891C14.6797 15.5 14.8594 15.2812 14.8594 14.9688V9.73438C14.8594 9.42969 14.6797 9.21094 14.2891 9.21094H13.5C13.0938 9.21094 12.9141 9.42969 12.9141 9.73438V14.9688C12.9141 15.2812 13.0938 15.5 13.5 15.5Z'
        fill='currentColor'
      />
    </Icon>
  );
}
